import { Union } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class IsValid extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Unvalidated", "Valid", "Invalid"];
    }
}

export function IsValid$reflection() {
    return union_type("Components.StatefulFormFields.IsValid", [], IsValid, () => [[], [], [["Item", string_type]]]);
}

